import { createRoute } from "apps/visits/packages/shared/models/Route";

export const routes: Record<string, ReturnType<typeof createRoute>> = {
  limitReached: createRoute("/brak-miejsc"),
  finishedAction: createRoute("/akcja-zdrowia-zakonczona"),
  runOutOfSlots: createRoute("/brak-slotow-czasowych"),
  homepage: createRoute("/"),
  catalog: createRoute("/wybierz-pakiet"),
  selectTimeSlot: createRoute("/wybierz-termin"),
  upsell: createRoute("/dokup-produkty"),
  phoneVerification: createRoute("/weryfikacja-numeru-telefonu"),
  phoneVerificationError: createRoute("/blad-weryfikacji-telefonu"),
  login: createRoute("/logowanie"),
  simplifyRegistration: createRoute("/uproszczona-rejestracja"),
  registration: createRoute("/rejestracja"),
  summary: createRoute<{ uuid: string }>("/:uuid/podsumowanie"),
  thankYou: createRoute<{ uuid: string }>(`/:uuid/dziekujemy`),
};
